// extracted by mini-css-extract-plugin
export default {"root":"HeaderDietFoodType_root__LCQ2s","header":"HeaderDietFoodType_header__NZRKE","placeHolderShimmer":"HeaderDietFoodType_placeHolderShimmer__4AvbC"};